import React from "react";

const TermsAndConditions = () => {
    return (
        <div className='container mt-3'>

            <div className="row mb-4">
                <div className="col-md-12 mt-4 mb-2">
                    <h1 className='text-center mb-3 h1 fw-bold'>Terms and Conditions</h1>
                </div>
                <div className="shadow-sm p-4 pb-2 border rounded-3 bg-white">
                    <div className="row align-items-center ">
                        <h5 className="fw-bolder">1. Introduction</h5>

                        <p>EXIM INDIA, all-India recognised premier publishing house, provides an electronic version of the newspaper (Dcopy) to its subscribers.
                            These Terms and Conditions govern the use of the Dcopy and the subscription services provided by [Your Company Name].</p>

                        <h5 className="fw-bolder">2. Subscription</h5>

                        <p>2.1. To access the Dcopy, you must subscribe to our services by creating an account and paying the applicable subscription fee.</p>

                        <p>2.2. You must provide accurate and complete information during the subscription process.</p>

                        <p>2.3. Your subscription will automatically renew for the chosen period (annually) unless you cancel it before the end of the current period.</p>

                        <h5 className="fw-bolder">3. Payment</h5>

                        <p>3.1. The subscription fee will be charged to your credit/debit card or other payment method on a recurring basis.</p>

                        <p>3.2. You are responsible for ensuring that your payment method is valid and up-to-date.</p>

                        <h5 className="fw-bolder">4. Access and Usage</h5>

                        <p>4.1. You may access the Dcopy through our website.</p>

                        <p>4.2. You agree to use the Dcopy for personal, non-commercial purposes only.</p>

                        <p>4.3. You must not share your login credentials or subscription with anyone.</p>

                        <h5 className="fw-bolder">5. Intellectual Property</h5>

                        <p>5.1. The Dcopy and its contents are protected by copyright, trademark, and other intellectual property laws.</p>

                        <p>5.2. You must not reproduce, distribute, or display any content from the Dcopy without our prior written permission.</p>

                        <h5 className="fw-bolder">6. Disclaimer and Limitation of Liability</h5>

                        <p>6.1. We do not guarantee that the Dcopy will be error-free, uninterrupted, or secure.</p>

                        <p>6.2. We will not be liable for any damages or losses arising from your use of the Dcopy.</p>

                        <h5 className="fw-bolder">7. Termination</h5>

                        <p>7.1. We may terminate or suspend your subscription at any time without notice.</p>

                        <p>7.2. You may cancel your subscription at any time through your account settings.</p>

                        <h5 className="fw-bolder">8. Governing Law</h5>

                        <p>8.1. These Terms and Conditions will be governed by and construed in accordance with the laws of India.</p>

                        <h5 className="fw-bolder">9. Changes to Terms and Conditions</h5>

                        <p>9.1. We may modify these Terms and Conditions at any time without notice.</p>

                        <p>9.2. Your continued use of the Dcopy will constitute your acceptance of the modified Terms and Conditions.</p>

                        <p>By subscribing to our Dcopy, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>




                    </div>
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions;